export const sx = {
    '&:last-child td, &:last-child th': {border: 0},
    '.lightTheme &:nth-of-type(odd)': {
        backgroundColor: '#d9d9d933',
        // backgroundColor: '#fff',
    },
    '.lightTheme thead &': {
        backgroundColor: '#fff',
    },
}